import { colors, spacing, measures } from 'styles/variables'
import { css } from '@emotion/core'

const { unit } = measures

export default {
  container: css`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${colors.grays.gray7};
    border-radius: ${unit * 4}px;
    height: ${unit * 6}px;
    box-sizing: border-box;
    padding: ${spacing(1.5)};
    gap: ${spacing(1.25)};
    min-width: ${unit * 25}px;
    cursor: pointer;
    transition: all 0.3s ease;
    user-select: none;
    color: ${colors.white100};

    :hover {
      color: ${colors.greens.green7};
    }
  `,

  arrow: css`
    margin-left: auto;
  `,
}
